import type { Handleiding } from './soort';

export const it: Handleiding = {
  code: 'it',
  titel: 'Guida',
  inleiding:
    'Ask Gio Tolk traduce una conversazione tra due persone che non parlano la stessa lingua. Qui sotto trovi cosa fa ogni pulsante.',
  knop: 'Apri la guida',
  sluiten: 'Chiudi',
  groepGebruik: 'Partecipare',
  groepBeheer: 'Impostare e gestire',
  delen: [
    {
      titel: 'Parlare',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Parla',
          uitleg:
            'Tocca una volta per iniziare. La registrazione si ferma da sola appena stai zitto per poco più di un secondo, o se tocchi di nuovo. Dopo un minuto si ferma comunque.',
        },
        {
          kop: 'Un suono alla volta',
          uitleg:
            'Finché l’app parla, non puoi registrare. E finché registri, una traduzione in arrivo aspetta che tu abbia finito. Altrimenti il microfono registra l’app e crede che l’abbia detto tu.',
        },
        {
          kop: 'Scrivi qui il tuo messaggio',
          uitleg:
            'Funziona accanto al parlato e passa per la stessa traduzione. Invio manda, maiuscolo con invio va a capo.',
        },
        {
          kop: 'Tempo per correggere',
          uitleg:
            'Qui imposti quanti secondi hai per rileggere la frase trascritta prima che parta. A zero parte subito.',
        },
        {
          kop: 'Rileggere e inviare sempre di persona',
          uitleg:
            'Niente più orologio. Ogni frase aspetta che tu prema invia. Per chi vuole controllare ogni frase.',
        },
        {
          kop: 'Riprodurre subito la traduzione',
          uitleg:
            'È attivo. Disattivalo se preferisci prima leggere e decidere tu quando ascoltare.',
        },
      ],
    },
    {
      titel: 'Leggere i messaggi',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Quello che è grande',
          uitleg:
            'Quello che è nella TUA lingua è grande. Nella tua frase è il testo originale, così puoi controllare se l’app ti ha capito bene. In una frase dell’altro è la traduzione.',
        },
        {
          kop: 'Aprire l’originale o la traduzione',
          uitleg: 'L’altra lingua sta sotto, chiusa. Tocca la riga per aprirla.',
        },
        {
          kop: 'Il triangolino',
          uitleg: 'Riproduce di nuovo la traduzione.',
        },
        {
          kop: 'La testa che parla',
          uitleg:
            'Riproduce la registrazione dell’altro. Compare solo su un messaggio PARLATO e solo se «manda anche la tua voce» è attivo. Un messaggio scritto non ha registrazione.',
        },
      ],
    },
    {
      titel: 'Pulsanti in alto nello schermo',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Meno e più',
          uitleg: 'Rende il testo più piccolo o più grande. In cinque passi, e resta salvato.',
        },
        {
          kop: 'Il microfono',
          uitleg: 'Nasconde il pulsante per parlare se scrivi soltanto. Così guadagni spazio.',
        },
        {
          kop: 'La tastiera',
          uitleg:
            'Nasconde il campo di testo. Ne resta sempre attivo uno dei due, altrimenti non potresti più dire niente.',
        },
      ],
    },
    {
      titel: 'Entrare',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Che lingua parli',
          uitleg:
            'Questa scelta determina anche la lingua dei pulsanti e degli avvisi. Vedete quindi due schermi diversi, ed è voluto.',
        },
        {
          kop: 'La tua voce nella traduzione',
          uitleg:
            'Scegli se suoni come uomo o come donna. Questo appartiene a TE, non alla stanza: ogni partecipante sceglie separatamente.',
        },
        {
          kop: 'Autorizzazione per il microfono',
          uitleg:
            'Il browser la chiede all’ingresso. Se dici di no, puoi ancora scrivere. Puoi dare l’autorizzazione anche dopo, dal lucchetto nella barra degli indirizzi.',
        },
      ],
    },
    {
      titel: 'In basso, chiuso',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'Glossario di sicurezza',
          uitleg:
            'Parole che devono essere sempre tradotte allo stesso modo: nomi, termini tecnici, marchi. Vale per tutta la stanza.',
        },
        {
          kop: 'Modificare le impostazioni',
          uitleg:
            'Lingua, voce, tono e correzione ortografica si cambiano anche NEL MEZZO della conversazione. Quello che cambi qui vale subito per tutti e due.',
        },
      ],
    },
    {
      titel: 'Iniziare una conversazione',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'Nome della conversazione',
          uitleg:
            'Può restare vuoto. Compare solo in alto sul tuo schermo, così sai con chi parli.',
        },
        {
          kop: 'Parlante 1 e parlante 2',
          uitleg:
            'Le due lingue di questa conversazione. Chi entra per primo prende il primo posto. Puoi ancora scambiare le lingue più tardi.',
        },
        {
          kop: 'Tono della traduzione',
          uitleg:
            'A sinistra scegli il tu o il lei, a destra l’atmosfera: neutra, amichevole, professionale, ufficiale o di coppia. Senza indicazioni il modello sceglie quasi sempre la forma formale, e in una conversazione normale suona distante.',
        },
        {
          kop: 'Manda anche la tua voce',
          uitleg:
            'L’altro può sentire la tua registrazione oltre alla traduzione. Comodo per imparare una lingua. Disattivalo in una conversazione delicata: chi riceve la registrazione può conservarla.',
        },
        {
          kop: 'Correggi gli errori nel tuo testo',
          uitleg:
            'È attivo. Disattivalo per vedere cosa ha capito davvero il modello. Se esce una frase strana, sai se è stata capita male o capita bene e poi levigata.',
        },
        {
          kop: 'Con codice PIN',
          uitleg:
            'Comunica il codice a voce, non nello stesso messaggio del link. Questo protegge da un link inoltrato.',
        },
        {
          kop: 'Il codice QR',
          uitleg:
            'Fallo scansionare all’altro, oppure manda il link. Una stanza scade da sola dopo quattro ore.',
        },
      ],
    },
    {
      titel: 'Cosa succede alla tua conversazione',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'Il testo non viene conservato',
          uitleg:
            'Quello che dite non finisce nel database. Solo quando e quanto si è parlato, per i costi.',
        },
        {
          kop: 'Le registrazioni spariscono da sole',
          uitleg: 'L’audio resta dieci minuti in memoria e poi se ne va.',
        },
        {
          kop: 'La stanza scade',
          uitleg: 'Quattro ore dopo la creazione. Dopo il link non funziona più.',
        },
        {
          kop: 'C’è un budget',
          uitleg:
            'Per stanza e per mese. Se si esaurisce, l’app smette di tradurre e lo dice. Non è un guasto.',
        },
      ],
    },
  ],
};
